"use strict";

import angular from "angular";


angular.module("nucont.accounting.company.demonstrations").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider.state("nucont.accounting.company.demonstrations.fin", {
        url: "/demonstracoes/financeiro",
        views: {
            "demonstrationView@nucont.accounting.company.demonstrations": {
                component: "financialDemonstrationsComponent",
                bindings: { companyData: "CompanyData" }
            }
        },
        params: {
            source: { value: "financeiro", dynamic: true }
        }
    });
}
